class DomCustomerReviewCarousel extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.savedInnerHTML = this.innerHTML
    this.previousWindowWidth = window.innerWidth
    this.initSwipers()
    this.initAutoPlayToggle()
    window.addEventListener('resize', this.resizeCheck.bind(this))
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeCheck.bind(this))
  }

  resizeCheck() {
    const newWindowWidth = window.innerWidth

    /*
      Swiper effects can't be adjusted on breakpoints
      re-render and initialize swiper if page goes from
      mobile -> dekstop or dekstop -> mobile
    */
    if (
      (newWindowWidth < 990 && this.previousWindowWidth >= 990) ||
      (newWindowWidth >= 990 && this.previousWindowWidth < 990)
    ) {
      this.innerHTML = this.savedInnerHTML
      this.initSwipers()
      this.initAutoPlayToggle()
    }

    this.previousWindowWidth = newWindowWidth
  }

  initSwipers() {
    this.imageSwiper = this.querySelector('.js-image-swiper')
    this.quoteSwiper = this.querySelector('.js-quote-swiper')
    this.productSwiper = this.querySelector('.js-product-swiper')

    if (!this.imageSwiper || !this.quoteSwiper || !this.productSwiper) {
      return null
    }

    /*
      Update attributes depending on mobile or desktop
      Only initialize product swiper on mobile
    */
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.imageSwiper.setAttribute('effect', 'fade')
      this.quoteSwiper.removeAttribute('controller-control')

      // Remove extra slides on desktop
      this.querySelectorAll('[data-parent-index]').forEach((elm) => {
        if (Number(elm.dataset.parentIndex || 0) > 0) {
          elm.remove()
        }
      })
    } else {
      this.imageSwiper.setAttribute('slides-per-view', '3')
      this.productSwiper.initialize()

      // Inject styles to mobile image wrapper
      Object.assign(this.imageSwiper, {
        injectStyles: [
          `
            .swiper {
              overflow: visible;
              width: 85%;
            }
          `,
        ],
      })
    }

    // Initialize sliders
    this.imageSwiper.initialize()
    this.quoteSwiper.initialize()

    // Event Listners to connect to quote slider
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.quoteSwiper.addEventListener('swiperslidechange', () => {
        this.imageSwiper.swiper.slideToLoop(this.quoteSwiper.swiper.realIndex)
      })
    } else {
      this.quoteSwiper.addEventListener(
        'swiperslidenexttransitionstart',
        () => {
          this.imageSwiper.swiper.slideNext()
        }
      )

      this.quoteSwiper.addEventListener(
        'swiperslideprevtransitionstart',
        () => {
          this.imageSwiper.swiper.slidePrev()
        }
      )

      this.quoteSwiper.addEventListener('swiperslidechange', () => {
        this.productSwiper.swiper.slideToLoop(this.quoteSwiper.swiper.realIndex)
      })
    }
  }

  initAutoPlayToggle() {
    const toggle = this.querySelector('.js-slider-autoplay-toggle')
    if (!toggle || !this.quoteSwiper) {
      return null
    }

    toggle.addEventListener('click', () => {
      toggle.classList.contains('paused')
        ? this.quoteSwiper.swiper?.autoplay.start()
        : this.quoteSwiper.swiper?.autoplay.stop()

      toggle.classList.toggle('paused')
    })
  }
}

customElements.define('customer-review-carousel', DomCustomerReviewCarousel)
